import { createContext, useContext, useState } from "react";

const ElemContext = createContext();

export const ElemProvider = ({ children }) => {
  const [student, setStudent] = useState(null);
  const [examiner, setExaminer] = useState(null);
  const [groups, setGroups] = useState([]);
  const [examiners, setExaminers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [studentNoGroup, setStudentNoGroup] = useState([]);
  const [selectedStudentNoGroup, setSelectedStudentNoGroup] = useState([]);
  const [selectedStudentInGroup, setSelectedStudentInGroup] = useState([]);

  return (
    <ElemContext.Provider
      value={{
        student,
        setStudent,
        examiner,
        setExaminer,
        groups,
        setGroups,
        examiners,
        setExaminers,
        search,
        setSearch,
        selectedGroup,
        setSelectedGroup,
        studentNoGroup,
        setStudentNoGroup,
        selectedStudentNoGroup,
        setSelectedStudentNoGroup,
        selectedStudentInGroup,
        setSelectedStudentInGroup,
      }}
    >
      {children}
    </ElemContext.Provider>
  );
};

export const useElemContext = () => useContext(ElemContext);
